/* globals d3,nv*/
import magic from 'libs/magic_numbers';

angular.module('zc.zenclerkS')

  .component('zcsTrackingTagChecker', {
    templateUrl: '/templates/zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker.html',
    bindings: {
      project: '<',
      // in setup page return should not be shown
      showReturn: '<',
      onComplete: '&'
    },
    controllerAs: 'vm',
    controller: ZcsTrackingTagCheckerController,
  });

ZcsTrackingTagCheckerController.$inject = ['$element', '$interval', '$rootScope', '$scope', '$state', '$timeout', 'Devise', 'MongoHistory', 'ZcsOemService'];
function ZcsTrackingTagCheckerController($element, $interval, $rootScope, $scope, $state, $timeout, Devise, MongoHistory, ZcsOemService) {
  const vm = this;

  const HISTORIES_TO_GET = 200;
  const colorPrimary = '#1DD5A3';
  const colorSecondary = '#775BD6';
  const colorTertiary = '#ff5c79';
  const DEFAULT_REQUIRED_HISTORIES = 5;
  const REQUIRED_HISTORIES = {
    makeshop: 1
  };

  let chart;

  // variables
  vm.histories = [];
  vm.listUrls = [];
  vm.showDetails = !vm.project.tracking_tag_confirmed_at;
  vm.showRaw = false;
  vm.isLoading = false;
  vm.errors = {
    noHistories: false,
    notEnoughSamples: false,
    notFoundPcOrTablet: false,
    notFoundSP: false,
  };
  vm.interval = undefined;
  vm.lastHistoryAt = undefined;

  // actions
  vm.refresh = refresh;
  vm.complete = complete;
  vm.toggleDetails = toggleDetails;
  vm.toggleRaw = toggleRaw;
  vm.hasTagErrors = hasTagErrors;
  vm.goToNextStep = goToNextStep;

  vm.host = ZcsOemService.getPublishHostForProject(vm.project);

  this.$onInit = () => {
    // if there is limit for specific shopping cart, use it
    vm.currentRequiredHistories = DEFAULT_REQUIRED_HISTORIES;
    if(REQUIRED_HISTORIES[vm.project.shopping_cart_asp]) {
      vm.currentRequiredHistories = REQUIRED_HISTORIES[vm.project.shopping_cart_asp];
    }

    refresh();

    $scope.$on('$destroy', () => {
      stopIntervals();
    });
  };

  function refresh() {
    if(vm.isLoading) return;

    vm.isLoading = true;

    const fetchParams = {
      apikey: vm.project.apikey
    };

    if(vm.lastHistoryAt) {
      fetchParams.opened_at = {
        $gt: vm.lastHistoryAt
      };
    }

    vm.errors.noHistories = false;

    MongoHistory.find(fetchParams, {
      sort: {
        opened_at: -1
      },
      limit: HISTORIES_TO_GET
    }).then(historiesResult => {
      vm.histories = vm.histories.concat(historiesResult);

      if(vm.histories.length === 0) {
        vm.errors.noHistories = true;
        return;
      }

      vm.histories = _.chain(vm.histories)
        .uniqBy(d => d._id)
        .sortBy(d => -d.opened_at)
        .value();

      // Take the last opened_at so that we don't get duplicates
      vm.lastHistoryAt = _.sortBy(vm.histories, d => -d.opened_at)[0].opened_at;

      createDeviceGraph(vm.histories);

      let foundPcOrTablet = false;
      let foundSP = false;
      _.each(vm.histories, history => {
        if(history.device === 'pc' || history.device === 'tablet') foundPcOrTablet = true;
        if(history.device === 'sp') foundSP = true;
      });
      // because these are errors, make them be true
      vm.errors.notFoundPcOrTablet = !foundPcOrTablet;
      vm.errors.notFoundSP = !foundSP;

      vm.percentages = {
        pc: _.filter(vm.histories, history => history.device === 'pc').length / HISTORIES_TO_GET * 100,
        sp: _.filter(vm.histories, history => history.device === 'sp').length / HISTORIES_TO_GET * 100,
        tablet: _.filter(vm.histories, history => history.device === 'tablet').length / HISTORIES_TO_GET * 100,
      };

      vm.urls = _.chain(vm.histories)
        .groupBy(history => history.url)
        .map((histories, url) => { return { url: url, count: histories.length } })
        .value();

      // Do processing here instead of angular view filters to avoid flickering
      vm.listUrls = _.chain(vm.urls)
        .sortBy(d => -d.count)
        .take(10)
        .value();

      // If there is cart specific limit, use it
      if(vm.urls.length < vm.currentRequiredHistories) {
        vm.errors.notEnoughSamples = true;
      }

      if(!vm.errors.noHistories && !vm.errors.notEnoughSamples) {
        complete();
      }
    })
      .finally(() => {
        vm.isLoading = false;

        // loop for new histories in the background
        if(!vm.interval) {
          vm.interval = $interval(refresh, magic.ZCLITE_TRACKING_TAG_AUTOCHECK_INTERVAL);
        }
      });
  }

  function hasTagErrors() {
    let hadErrors = false;

    _.each(vm.errors, (v, k) => {
      if(v) {
        hadErrors = true;
      }
    });

    return hadErrors;
  }

  function toggleRaw() {
    vm.showRaw = !vm.showRaw;
  }

  function toggleDetails() {
    vm.showDetails = !vm.showDetails;

    // update chart because it might be shown as too small if element was
    // hidden when it was created
    if(chart) {
      $timeout(chart.update, 100);
    }
  }

  function goToNextStep() {
    // no need to get more data (+ without this tests are difficult)
    stopIntervals();

    $state.go('zenclerkS.project.setup.conversionTag');
  }

  function complete() {
    if(!vm.project.tracking_tag_confirmed_at) {
      vm.onComplete();
      // emiting is required for settings pages
      $rootScope.$broadcast('trackingTagFound');
    }
  }

  function createDeviceGraph(histories) {
    let svgSelector = $element.find('.device-graph svg');
    svgSelector.html('');
    if(histories.length === 0) return;

    // create percentage per device
    let data = _.chain(histories)
      .groupBy(d => d.device)
      .map((v, k) => { return { key: k, value: v.length / histories.length * 100 } })
      .value();

    nv.addGraph(() => {
      chart = nv.models.pieChart()
        .x(d => d.key)
        .y(d => d.value)
        .labelType('percent')
        .donut(true)
        .donutRatio(0.35)
        .color([colorPrimary, colorSecondary, colorTertiary]);

      chart.valueFormat(d => d3.format(',d')(d) + '%');

      let svg = d3.select(svgSelector[0]);
      svg.datum(data)
        .call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  function stopIntervals() {
    if(vm.interval) {
      $interval.cancel(vm.interval);
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker.js